import React from 'react';

// MedHaul's flower mark, lifted from the wordmark (assets/medhaulIcon.svg) so it
// can be tinted and sized on its own — the wordmark file carries the type too.
export const MedHaulMark = ({ fill = 'currentColor', className, size = 24 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='131 131 270 270'
    fill={fill}
    className={className}>
    <path d='M397.9,210.5h-76.5v-77.4h-37l-10.8,30.6c-2.5,7.2-12.7,7.2-15.2,0l-10.8-30.6h-37v77.4h-77.2v37l30.6,10.8c7.2,2.5,7.2,12.7,0,15.2l-30.6,10.8v37h77.2v77.2h37l10.8-30.6c2.5-7.2,12.7-7.2,15.2,0l10.8,30.6h37v-77.2h76.5v-37l-30.6-10.8c-7.2-2.5-7.2-12.7,0-15.2l30.6-10.8v-37ZM295.1,162.8h5.5v47.7h-22.2l16.7-47.7ZM300.6,298.6v2h-69.3v-69.3h69.3v67.3ZM231.3,162.8h5.4l16.7,47.7h-22.1v-47.7ZM163,236.8v-5.5h47.5v22.1l-47.5-16.6ZM163,300.6v-5.4l47.5-16.6v22h-47.5ZM236.8,368.9h-5.5v-47.5h22.1l-16.6,47.5ZM300.6,368.9h-5.4l-16.6-47.5h22v47.5ZM368.2,295.1v5.5h-46.8v-21.9l46.8,16.4ZM368.2,236.7l-46.8,16.4v-21.8h46.8v5.4Z' />
  </svg>
);
